
<template>
  <b-modal size="lg" ref="modal" @close="close" centered no-close-on-backdrop>
  <div 
    :class="{ 'pdf-viewer-container custom-scroll': true, 'expanded': isExpanded }"
    :style="'max-height:960px;' "
    >
    <div :class="{ 'py-2': !isExpanded, 'w-100': isExpanded }" :style="`width: ${!isExpanded ? '100%' : ''}`">
      <attachment-button-header
        :attachment-url="url"
        :is-expanded="false"
        :isXlsx=true
        @zoom-in="zoomIn"
        @zoom-out="zoomOut"
        @download-attachment="downloadXLSX"
      />
    </div>
    <div id="xlsx-wrapper" tabindex="0" @keydown.esc="closePDF">
      <div id="xlsx-table" class="p-1 mb-2 xlsx-table" ref="tableau" v-html="html"></div>
    </div>
  </div>
    </b-modal>
</template>
  
<script>
import { ref } from "vue";
import { saveAs } from 'file-saver';
import { read, utils, writeFileXLSX } from 'xlsx';
import AttachmentButtonHeader from './attachmentButtonHeader.vue';
  
export default {
  name: "xlsx-viewer",
  components: { AttachmentButtonHeader },
  props: [
    "url",
    "sizing",
    'includeExpand',
    'isExpanded',
    'name'
  ],
  data() {
    return {
      html: null,
      tableau: null,
    };
  },
  mounted() {
    this.$refs["modal"].show();
    this.loadXlsx(this.url);
  },
  methods: {
    downloadXLSX() {
      fetch(this.url, {method: 'GET'})
      .then(res => {
        return res.blob();
      })
      .then(blob => {
        const filename = this.name.indexOf('.xlsx') != -1 ? this.name : `${this.name}.xlsx`;
        saveAs(blob, filename);
      })
      .catch(err => {
        console.error('err: ', err);
        this.$showAlert(err?.message ?? "Something went wrong");
      });
    },
    async loadXlsx(url) {
      const arrayBuffer = await (await fetch(url)).arrayBuffer();
      const wb = read(arrayBuffer, { type: 'array' });
      this.html = utils.sheet_to_html(wb.Sheets[wb.SheetNames[0]]); // update data
    },
    exportFile() {
      const wb = utils.table_to_book(this.$refs.tableau.getElementsByTagName("TABLE")[0]);
      writeFileXLSX(wb, this.name);
    },
    zoomIn() {
      if (this.zoom < 15) {
        this.zoom += 1;
      }
    },
    zoomOut() {
      if (this.zoom > 10) {
        this.zoom -= 1;
      }
    },
    setZoomBasedOnWidth() {
      const width = window.innerWidth;
      if (width <= 480) {
        this.zoom = 15;
      } else if (width <= 768) {
        this.zoom = 14;
      } else if (width <= 992) {
        this.zoom = 13;
      } else if (width <= 1200) {
        this.zoom = 12;
      } else {
        this.zoom = 10;
      }
    },
    zoomAndRender() {
      this.setZoomBasedOnWidth();
    },
    close() {
      this.$refs['modal'].hide()
    },
  },
  
  watch: {
    url() {
      this.loadXlsx(this.url);
    }
  }
};
</script>
  
<style scoped lang="scss">
.custom-scroll::-webkit-scrollbar {
  display: none; 
}
@import './pdfViewer.scss'
</style>
